// extracted by mini-css-extract-plugin
export default {"articleList":"ArticleList_articleList__+om5i","articleListItems":"ArticleList_articleListItems__NgjdD","articleListItem":"ArticleList_articleListItem__Ks0CQ"};